<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
.noneClass {
  color: #999;
  text-align: center;
  font-size: 18px;
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue